import * as React from "react"
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import NavigationDropdown from "./navigationDropdown";
import { LocaleContext } from "../../context/LocaleContext";
import CustomLink from "../CustomLink";

export interface NavigationProps {
    locale
    navigationItem: {
        title: string;
        customLink: string;
        anchor?: string
        NavigationSubItems: {
            title: string
            anchor?: string
            slug?: string
            sub_page: {
                slug: string
                pageTitle: string
            }
        }[]
    }[]
    ContactUsButton: {
        link: string
        text: string
    }
}
interface Props {
    navigation: NavigationProps
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            [theme.breakpoints.up('md')]: {
                flexDirection: 'row',
            },
        },
        navItem: {
            textDecoration: 'none',
            textAlign: 'center',
            fontSize: 16,
            fontWeight: 600,
            lineHeight: 5.06,
            color: "#202338",
            cursor: "pointer",
            [theme.breakpoints.up('md')]: {
                paddingRight: 30,
            },
        },
    }),
);

const Navigation: React.FC<Props> = ({ navigation }) => {
    const classes = useStyles();
    const localeContext = React.useContext(LocaleContext);

    return <div className={classes.root}>

        {navigation && navigation.navigationItem.map((item, i) => {
            const hasSubitems = item.NavigationSubItems && item.NavigationSubItems.length !== 0;

            if (hasSubitems) {
                return <NavigationDropdown subItems={item.NavigationSubItems} label={item.title} key={i} locale={navigation.locale} />
            }

            return (
                <CustomLink
                    key={item.customLink}
                    link={item.customLink}
                    anchor={item.anchor || undefined}
                    locale={localeContext.locale}
                    className={classes.navItem}
                    text={item.title}
                />
            )
        })
        }
    </div>
}

export default Navigation;
